module.exports = __webpack_public_path__ + "static/w_tuskegee-fc2f99de28e441cc6600187c4f3d86e0.png";